import { IterableElement } from 'type-fest'

import { Ticker } from './ticker'

export const LTC_TICKERS = [Ticker.LTC]

export type LtcTicker = IterableElement<typeof LTC_TICKERS>
